"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromDto = exports.toDto = void 0;
const tslib_1 = require("tslib");
const id = tslib_1.__importStar(require("./id"));
/**
 * Converts offset-based string selections to CRDT ID-based selections. The
 * offset-based selections are relative to the current state of the string, and
 * will be converted to stable CRDT ID-based selections, which are stable across
 * concurrent edits.
 *
 * @param str The "str" node instance.
 * @param selections Collection of offset-based selections in the string.
 * @returns RGA selection entry, where all offset-based selection converted to
 *     stable CRDT ID-based selections.
 */
const toDto = (str, selections) => {
    const clock = str.api.model.clock;
    const sid = clock.sid;
    const nodeId = id.toDto(sid, str.node.id);
    const cursors = [];
    for (const selection of selections) {
        let anchor = 0, focus = -1;
        if (typeof selection === 'number')
            anchor = selection;
        else
            [anchor, focus = anchor] = selection;
        if (focus === anchor)
            focus = -1;
        let cursor;
        try {
            const anchorId = str.findId(anchor - 1);
            const anchorPoint = [id.toDto(sid, anchorId)];
            if (focus >= 0) {
                const focusId = str.findId(focus - 1);
                const focusPoint = [id.toDto(sid, focusId)];
                cursor = [anchorPoint, focusPoint];
            }
            else {
                cursor = [anchorPoint];
            }
        }
        catch {
            cursor = [[id.toDto(sid, str.node.id)]];
        }
        cursors.push(cursor);
    }
    const selection = ['', '', sid, clock.time, {}, 4 /* JsonCrdtDataType.str */, nodeId, cursors];
    return selection;
};
exports.toDto = toDto;
/**
 * Convert a CRDT ID to a view offset (the cursor position after that
 * character). Returns 0 when the ID matches the node itself (i.e. before
 * the first character).
 */
const findOffset = (str, tsId) => {
    const nodeId = str.id;
    if (nodeId.sid === tsId.sid && nodeId.time === tsId.time)
        return 0;
    const chunk = str.findById(tsId);
    if (!chunk)
        return 0;
    const pos = str.pos(chunk);
    const charIndex = pos + (chunk.del ? 0 : tsId.time - chunk.id.time);
    return charIndex + 1;
};
/**
 * Converts a CRDT ID-based RGA selection back to offset-based string
 * selections. This is the inverse of {@link toDto}.
 *
 * @param model The JSON CRDT model containing the "str" node.
 * @param selection The RGA selection DTO to convert.
 * @returns Collection of offset-based selections, or an empty array if the
 *     node is not found or is not a "str" node.
 */
const fromDto = (model, selection) => {
    const [_documentId, _uiLocationId, sid, _time, _meta, type, nodeIdDto, cursors] = selection;
    const result = [];
    if (type !== 4 /* JsonCrdtDataType.str */)
        return result;
    const nodeId = id.fromDto(sid, nodeIdDto);
    const str = model.index.get(nodeId);
    if (!str || str.name() !== 'str')
        return result;
    for (const cursor of cursors) {
        const [anchorPointDto, focusPointDto] = cursor;
        const anchorId = id.fromDto(sid, anchorPointDto[0]);
        const anchorOffset = findOffset(str, anchorId);
        if (focusPointDto) {
            const focusId = id.fromDto(sid, focusPointDto[0]);
            const focusOffset = findOffset(str, focusId);
            result.push([anchorOffset, focusOffset]);
        }
        else {
            result.push([anchorOffset]);
        }
    }
    return result;
};
exports.fromDto = fromDto;
